import React from "react";
import { enablePushNotifications } from "@/lib/push";
import { callWithAuth, postFirebasePushToken } from "@/api/Api";
import { usePostHog } from "posthog-js/react";
interface NotificationPopUpProps {
  onClose: () => void;
}

const NotificationPopUp: React.FC<NotificationPopUpProps> = ({ onClose }) => {
  const posthog = usePostHog();

  const handleEnablePush = async () => {
    const token = await enablePushNotifications();
    if (token != "") {
      const data = {
        token: token,
      };
      try {
        posthog.capture("new_user_push_notification_enabled");
      } catch (error) {
        console.error(
          "Error posting new user push notification enabled:",
          error
        );
      }
      try {
        await callWithAuth(postFirebasePushToken, data);
      } catch (error) {
        console.error("Error posting Firebase push token:", error);
      }
    }
    onClose();
  };

  return (
    <div className="flex flex-col w-64 h-auto rounded-xl border border-[var(--color-grey-light)] items-center justify-between bg-[var(--color-bg)]">
      <div className="flex flex-col w-full items-center justify-center gap-2 p-4 pb-6">
        <div className="text-center text-lg font-semibold">
          🦜 "Parrot" Would Like to Send You Notifications
        </div>
        <div className="text-center text-sm">
          Notifications may include alerts, sounds and icon badges. These can be
          configured in Settings.
        </div>
      </div>
      <div className="flex flex-row w-full h-16 justify-evenly items-center border-t text-center text-[var(--color-blue)]">
        <div
          className="flex w-full h-full items-center justify-center text-center border-r border-[var(--color-grey-light)]"
          onClick={() => {
            onClose();
          }}
        >
          Don't Allow
        </div>
        <div
          className="flex w-full h-full items-center justify-center text-center font-semibold"
          onClick={handleEnablePush}
        >
          Allow
        </div>
      </div>
    </div>
  );
};
export default NotificationPopUp;
